/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_Your_AnswerInputs */

const en_interview_practice_your_answer = /** @type {(inputs: Interview_Practice_Your_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Answer`)
};

const de_interview_practice_your_answer = /** @type {(inputs: Interview_Practice_Your_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Antwort`)
};

const fr_interview_practice_your_answer = /** @type {(inputs: Interview_Practice_Your_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta réponse`)
};

const es_interview_practice_your_answer = /** @type {(inputs: Interview_Practice_Your_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su respuesta`)
};

const it_interview_practice_your_answer = /** @type {(inputs: Interview_Practice_Your_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua risposta`)
};

const nl_interview_practice_your_answer = /** @type {(inputs: Interview_Practice_Your_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw antwoord`)
};

const pl_interview_practice_your_answer = /** @type {(inputs: Interview_Practice_Your_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoja odpowiedź`)
};

const fi_interview_practice_your_answer = /** @type {(inputs: Interview_Practice_Your_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vastauksesi`)
};

const da_interview_practice_your_answer = /** @type {(inputs: Interview_Practice_Your_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit svar`)
};

const sv_interview_practice_your_answer = /** @type {(inputs: Interview_Practice_Your_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditt svar`)
};

/**
* | output |
* | --- |
* | "Your Answer" |
*
* @param {Interview_Practice_Your_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_your_answer = /** @type {((inputs?: Interview_Practice_Your_AnswerInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Your_AnswerInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_your_answer(inputs)
	if (locale === "fr") return fr_interview_practice_your_answer(inputs)
	if (locale === "es") return es_interview_practice_your_answer(inputs)
	if (locale === "it") return it_interview_practice_your_answer(inputs)
	if (locale === "nl") return nl_interview_practice_your_answer(inputs)
	if (locale === "pl") return pl_interview_practice_your_answer(inputs)
	if (locale === "fi") return fi_interview_practice_your_answer(inputs)
	if (locale === "da") return da_interview_practice_your_answer(inputs)
	if (locale === "sv") return sv_interview_practice_your_answer(inputs)
	return en_interview_practice_your_answer(inputs)
});